import { Component, computed, inject } from '@angular/core';
import { StandardPageLayoutComponent } from '@layouts/standard-page/standard-page.component';
import { SharedCommonModule } from '@shared/common.module';
import { UserResourceService } from '@shared/resources/user-resource.service';
import { EduButtonComponent } from '@atoms/button/button.component';
import { EduIconComponent, Icons } from '@atoms/icon/icon.component';
import { openContactPage } from '@helpers/support';

@Component({
  templateUrl: './dashboard.component.html',
  imports: [SharedCommonModule, StandardPageLayoutComponent, EduButtonComponent, EduIconComponent],
})
export class DashboardPageComponent {
  private userResourceService = inject(UserResourceService);

  public Icons = Icons;

  welcomeFirstname = computed(() => {
    return this.userResourceService.user.value()?.firstname;
  });

  contactSupport() {
    openContactPage();
  }

  openNewFeaturesGuide() {
    window.open('https://edudip.com/blog-erste-schritte-mit-den-neuen-edudip-features/', '_blank');
  }
}
